module.exports = __webpack_public_path__ + "static/media/Ganga Ram Hospital.70e5d615.mp3";